import TroopSquares from "./TroopSquares";

export default TroopSquares;
